<template>
  <div class="mypage-user-confirm-pane">
    <user-confirm-form-section ref="userConfirmFormSection" @success-regist="regist" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'
import UserConfirmFormSection from '@/components/MypageUserConfirmPage/MypageUserConfirmPane/UserConfirmFormSection.vue'

/**
 * マイページ: 会員情報変更内容確認 コンテンツペイン
 */
export default defineComponent({
  name: 'MypageUserConfirmPane',
  components: {
    UserConfirmFormSection,
  },
  setup() {
    const userConfirmFormSection = ref<InstanceType<typeof UserConfirmFormSection>>()
    return {
      userConfirmFormSection,
    }
  },
  methods: {
    /**
     * 変更確認通知
     * todo: 仮処理
     */
    saveUserInfo(): void {
      this.userConfirmFormSection?.saveUserInfo()
    },
    regist(): void {
      this.$emit('success-regist')
    },
  },
})
</script>

<style lang="scss" scoped>
.mypage-user-confirm-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  padding-bottom: 136px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
